import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { AppErrors, NotFoundError } from '@fitness-force/models';;

import { environment } from '@fitness-force/environments';
import { throwError, Observable, pipe } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ChargeCategoryService {
  private http = inject(HttpClient);
  private router = inject(Router);


  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };


  getChargeCategories(tenantId: number,allParams:Array<string>=[]) {
    let parsedParams = new HttpParams()
    if(allParams.length > 0){

     allParams.forEach((p: any) => {

       parsedParams = parsedParams.append(p.name, p.value);
     });
    }
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_CATEGORY.GET_CHARGE_CATEGORIES
          .replace('{tenant_id}', tenantId.toString()),
        {headers: this.httpOptions.headers , params: parsedParams}
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }
  getSingleChargeCategory(tenantId: number,categoryId:number) {
    return this.http
      .get(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_CATEGORY.GET_CHARGE_CATEGORY_BY_ID
          .replace('{tenant_id}', tenantId.toString())
          .replace('{category_id}', categoryId.toString()),
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  updateChargeCategory(tenantId: number,ser_cat_id:number,data:any) {
    return this.http
      .put(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_CATEGORY.UPDATE_CHARGE_CATEGORY
          .replace('{tenant_id}', tenantId.toString())
          .replace('{category_id}', ser_cat_id.toString()),
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


createChargeCategory(tenantId: number,data:any) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_CATEGORY.CREATE_CHARGE_CATEGORY
          .replace('{tenant_id}', tenantId.toString()),
        data,
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }



  markActive(tenantId: number,ser_cat_id:number) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_CATEGORY.MARK_CHARGE_CATEGORY_ACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{category_id}', ser_cat_id.toString()),
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }

  markInActive(tenantId: number,ser_cat_id:number) {
    return this.http
      .post(
        environment.BASE_URL + CONST_URL_SEGEMENTS.CHARGE_CATEGORY.MARK_CHARGE_CATEGORY_INACTIVE
          .replace('{tenant_id}', tenantId.toString())
          .replace('{category_id}', ser_cat_id.toString()),
        {},
        this.httpOptions
      )
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((error: Response) => {
          if (error.status === 404) {
            return throwError(() => new NotFoundError(error));
          }
          return throwError(() => new AppErrors(error));
        })
      );
  }


}
